import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridTopHeader } from "../../../../components/styled";
import { adminTableColumns } from "../../../../data/mockTableColumns";
import { getAllAdmins } from "../../../../api/admins";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Admins = () => {
  const [admins, setAdmins] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();

  useEffect(() => {
    const fetchAllAdmins = async () => {
      try {
        const allAdmins = await getAllAdmins();
        setAdmins(allAdmins);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAllAdmins();
  }, []);

  // Filtered admins based on search query
  const filteredAdmins = admins.filter(
    (admin) =>
      admin.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      admin.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      admin.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DashboardLayout>
      {/* HEADER */}
      <DashboardHeader
        title="Admins"
        subtitle="List of All Admins Profile"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={filteredAdmins}
          columns={adminTableColumns}
          getRowId={(row) => row._id}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>
    </DashboardLayout>
  );
};

export default Admins;
